<template>
  <div
    id="shopbox"
    class="app-wrapper shopbox-app"
    :style="cssVars"
    v-show="killswitch && control_group == 0 && !isHidden && itfdk"
  >
    <!-- v-show="(dndEnabled || similarEnabled || recentEnabled) && killswitch" -->
    <div
      class="shopbox-main"
      :class="{
        'shopbox-mobile': isMobile(),
        'shopbox-portrait': portraitview,
        'shopbox-right': showOnRight,
        'shopbox-abtest': abtest,
        'shopbox-abtestitf': abtestitf,
        'shopbox-abtestsc': scabtest,
        'shopbox-dndtest': dndtest,
      }"
    >
      <p
        class="sb-outside-panel"
        @click="closeAnyPanel"
        v-if="similarOpen || recentOpen"
      ></p>

      <sb-fab
        :dnd="dndEnabled"
        :searchConfig="{ reach, parent, className: identifier, attr }"
        @toggleSimilar="toggleSimilar"
      ></sb-fab>

      <sb-menu
        ref="menu"
        v-show="menuOpen"
        :options="config.options"
        :cbtext="cbtext"
        :cblink="cblink"
        :recentlypurchased="recentlypurchased"
        :custombuttons="custombuttons"
        :logo="logo"
        :disablelogofilter="disablelogofilter"
        :logocentered="logocentered"
        @startTour="startTour"
        @togglePurchased="togglePurchased"
        @toggleRecent="toggleRecent"
        @toggleSimilar="toggleSimilar"
        @toggleCrosssell="toggleCrosssell"
      ></sb-menu>

      <sb-similar
        ref="similar"
        v-show="similarOpen"
        @toggleSimilar="toggleSimilar"
        :cid="cid"
      ></sb-similar>

      <sb-recent
        ref="recent"
        @toggleSimilar="toggleSimilar"
        @toggleRecent="toggleRecent"
        v-show="recentOpen"
        :cid="cid"
      ></sb-recent>
      <sb-purchased
        ref="purchased"
        @toggleSimilar="toggleSimilar"
        @togglePurchased="togglePurchased"
        v-show="purchasedOpen"
        :cid="cid"
        :recentlypurchased="recentlypurchased"
      ></sb-purchased>

      <sb-crosssell
        ref="crosssell"
        @toggleSimilar="toggleSimilar"
        :cid="cid"
        :enabled="crosssellEnabled"
        v-show="crosssellOpen"
      ></sb-crosssell>
      <sb-tour ref="shopboxTour" :productClass="parent"></sb-tour>

      <sb-call-out v-if="calloutVisible"></sb-call-out>
      <sb-cta
        ref="sbcta"
        @toggleRecent="toggleRecent"
        @toggleSimilar="toggleSimilar"
        @toggleCrosssell="toggleCrosssell"
      ></sb-cta>
    </div>
  </div>
</template>

<script>
import cta from "./components/CTA.vue";
import menu from "./components/Menu.vue";
import fab from "./components/Fab.vue";
import sbSimilar from "./components/Similar.vue";
import sbRecent from "./components/Recent.vue";
import sbPurchased from "./components/Purchased.vue";
import sbCrosssell from "./components/Crosssell.vue";
import sbTour from "./components/Tour.vue";
import sbCallOut from "./components/CallOut.vue";

import { mapState } from "vuex";
import seedrandom from "seedrandom";

import * as Sentry from "@sentry/browser";

export default {
  ref: "sb",
  components: {
    sbMenu: menu,
    sbFab: fab,
    sbTour: sbTour,
    sbCallOut: sbCallOut,
    sbSimilar: sbSimilar,
    sbRecent: sbRecent,
    sbPurchased: sbPurchased,
    sbCrosssell: sbCrosssell,
    sbCta: cta,
  },
  props: {
    right: Boolean,
    detailsidentifier: String,
    detailsattr: String,
    productdetails: {
      type: Array,
    },
    cid: String,
    logo: String,
    disablelogofilter: [String, Boolean],
    logocentered: [String, Boolean],
    maincolor: {
      type: String,
      default: "#083d77",
    },
    identifier: [String, Array],
    portrait: [String, Boolean],
    reach: [String, Number],
    attr: [String, Array],
    currency: String,
    similarembedselector: String,
    recentembedselector: String,
    decimalcomma: [String, Boolean],
    insert: [String, Boolean],
    insertclass: String,
    insertafter: String,
    custombuttons: String,
    productbanerdata: String,
    cbtext: String,
    cblink: String,
    currencyelement: String,
    filters: String,
    recentlypurchased: String,
    language: String,
    pricer: {
      type: [String, Number],
      detault: 90,
    },
    parent: [String, Array],
    productgrid: {
      type: Array,
    },
    homepage: {
      type: Array,
    },
    cartpage: {
      type: Array,
    },
    config: {
      type: Object,
      default() {
        return {
          options: {
            enabled: true,
            crosssell: { enabled: true },
            recent: {
              enabled: true,
            },
            similar: {
              dnd: true,
              enabled: true,
            },
          },
        };
      },
    },
  },
  data() {
    return {
      windowTop: 0,
      isHidden: false,
      abtest: false,
      abtestitf: false,
      dndtest: false,
      paneltest: false,
      scabtest: false,
    };
  },
  computed: {
    ...mapState([
      "menuOpen",
      "similarOpen",
      "crosssellOpen",
      "recentOpen",
      "purchasedOpen",
      "uuid",
      "control_flag",
      "similarEnabled",
      "dndEnabled",
      "recentEnabled",
      "similarProducts",
      "purchasedEnabled",
      "crosssellEnabled",
      "lastProductId",
      "c_page",
      "site",
      "exp",
      "now",
      "ctaOpen",
      "portraitview",
      "control_group",
      "content",
      "lang",
      "panelList",
    ]),
    showOnRight() {
      if (this.cid == "abc-school-supplies") {
        if (this.isMobile()) {
          return false;
        } else {
          return true;
        }
      } else if (this.cid == "silverdluxe") {
        return false;
      } else if (this.cid == "hanley") {
        return false;
      } else {
        return this.right;
      }
    },
    itfdk() {
      if (this.cid == "interfloradk") {
        if (
          this.enabledOnPage("productgrid") ||
          this.enabledOnPage("productdetails")
        ) {
          if (this.enabledOnPage("productgrid")) {
            let pathname = window.location.pathname;
            let disabledPaths = [
              "/produkter/anledninger/blomster-til-begravelse",
              "/produkter/anledninger/blomster-til-begravelse",
              "/produkter/anledninger/vegetativ-dekoration",
              "/produkter/anledninger/urnepynt",
              "/produkter/anledninger/kistepynt",
              "/produkter/anledninger/baredekorationer",
              "/produkter/anledninger/baarebuketter",
              "/produkter/anledninger/blomsterkranse",
              "/produkter/anledninger/bisaettelse",
              "/produkter/anledninger/begravelsesdekorationer",
              "/produkter/kondolencebuketter",
            ];
            if (!disabledPaths.includes(pathname)) {
              return true;
            }
          }
          if (this.enabledOnPage("productdetails")) {
            if (this.similarProducts.length > 0) {
              return true;
            }
          }
          return false;
        }
        return true;
      }
      return true;
    },
    killswitch() {
      let orgs = [
        "easons",
        "the-irish-store",
        "the-irish-store-uk",
        "babyzone",
        "mccabespharmacy",
        "carraigdonn",
        "stylecheat",
        "euronics",
        "toolstation",
        "silverdluxe",
        "fairfashionista",
        "fairfashionistase",
        "fairfashionistadk",
        "babame",
        "jDYc4TQbPwDI9rvThCm3",
      ];
      if (orgs.includes(this.cid)) {
        if (localStorage.getItem("shopboxAdmin")) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    isAdmin() {
      if (localStorage.getItem("shopboxAdmin")) {
        return true;
      } else {
        return false;
      }
    },
    isKos() {
      if (localStorage.getItem("isKos")) {
        return true;
      } else {
        return false;
      }
    },
    cssVars() {
      let mc =
        this.maincolor && this.maincolor != "null" ? this.maincolor : "#083d77";
      return {
        "--shopbox-main": mc,
      };
    },
    calloutVisible() {
      if (this.control_group == 0) {
        if (
          this.enabledOnPage("productgrid") &&
          window.location.pathname != "/"
        ) {
          // ||
          // (this.enabledOnPage("productgrid") &&
          //   window.location.pathname != "/" &&
          //   this.cid == "buildfourless") ||
          // (this.enabledOnPage("productgrid") &&
          //   window.location.pathname != "/" &&
          //   this.cid == "interflora") ||
          // (this.enabledOnPage("productgrid") &&
          //   window.location.pathname != "/" &&
          //   this.cid == "interfloradk") ||
          // this.isKos
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    windowTop() {
      let scroll30 = parseInt(document.body.scrollHeight / 5) < this.windowTop;

      if (scroll30) {
        // // console.log(this.windowTop);
        // if (this.control_group == 0) {
        // this.toggleSimilarCTA(this.lastProductId);
        // }
        window.removeEventListener("scroll", this.trackScroll);
      }
    },
    similarOpen(val) {
      if ((val == true || this.recentOpen == true) && this.isMobile()) {
        document.body.classList.add("shopbox-disable-website-scroll");
      } else {
        document.body.classList.remove("shopbox-disable-website-scroll");
      }
    },
    recentOpen(val) {
      if ((val == true || this.similarOpen == true) && this.isMobile()) {
        document.body.classList.add("shopbox-disable-website-scroll");
      } else {
        document.body.classList.remove("shopbox-disable-website-scroll");
      }
    },
    c_page(oldv) {
      console.log(oldv);
      if (oldv != null) {
        this.updateUserGroups();
        if (this.cid == "interflora") {
          this.language = "es";
          this.parent = ".block-product,.eb-article";
          this.pricer = 60;
          this.$store.commit("SET_PRICER", this.pricer);

          this.productgrid = [
            "body.catalog-category-view,#eb-searchField.opened,.cms-home",
          ];
          // if (this.isKos) {
          //   this.similarembedselector = ".block-product-detail";
          // }
        }
        this.$store.commit("UPDATE_LANG", this.language);

        if (this.cid == "stylecheat") {
          this.homepage = ["body.template-index", "/"];
          this.currencyelement = "#CurrencyData";
          this.identifier = ".bc-sf-filter-product-item-image a";
          this.attr = "href";
          this.detailsidentifier = "url";
        }
        this.initABTest();
        if (this.cid == "tony_kealys") {
          this.detailsidentifier = "url";
          this.detailsattr = null;
          this.productdetails = [".product", ".product-visualconstructor"];
          this.identifier = "a";
          this.attr = "href";

          this.similarembedselector = ".container";
        }
        if (this.cid == "tony_kealys_uk") {
          this.similarembedselector = ".container";
        }
        if (this.cid == "silverdluxe") {
          this.decimalcomma = true;
          this.$store.commit("SET_DECIMALCOMMA", this.decimalcomma);
          document.body.classList.add("sb-silverdluxe");
        }
        if (this.cid == "designerexchange") {
          document.body.classList.add("sb-designerexchange");
        }
        if (this.cid == "osullivansafety") {
          document.body.classList.add("sb-osullivansafety");
        }
        if (
          this.cid == "fairfashionista" ||
          this.cid == "fairfashionistadk" ||
          this.cid == "fairfashionistase"
        ) {
          this.detailsidentifier = "url";
          this.detailsattr = null;
          this.identifier = "a";
          this.attr = "href";
          document.body.classList.add("sb-fairfashionista");
        }
        if (this.cid == "fitpinkfitness") {
          if (this.control_group == 0) {
            document.body.classList.add("sb-fitpinkfitness-currency");
          }

          this.similarembedselector = null;
          this.insertafter = ".swatch-wrap";
          document.body.classList.add("sb-fitpinkfitness");
        }
        if (this.cid == "osullivanspharmacy") {
          //  this.parent = ".block-product,.eb-article";
          this.identifier = ".product_type_simple";
          this.pricer = 50;
          this.$store.commit("SET_PRICER", this.pricer);
          document.body.classList.add("sb-osullivanspharmacy");
        }
        if (this.cid == "mccabespharmacy") {
          document.body.classList.add("sb-mccabespharmacy");
          this.productgrid = [
            "body.page-products,body.catalogsearch-result-index,body.cms-home,.brand-page-featured-products",
          ];

          // console.log("mccabespharmacy", this.productgrid);
        }
        if (this.cid == "meagherspharmacy") {
          document.body.classList.add("sb-meagherspharmacy");

          this.productgrid = [
            "body.template-collection,body.template-search,body.snize-results-page",
          ];
          this.parent = ".product-item,.snize-product";
          this.identifier = "a";

          this.pricer = 50;
          this.$store.commit("SET_PRICER", this.pricer);
        }
        if (this.cid == "hanley") {
          this.pricer = 75;
          this.$store.commit("SET_PRICER", this.pricer);
          if (this.isKos) {
            this.similarembedselector = ".custom-container";
          }
        }
        if (this.cid == "babyzone") {
          document.body.classList.add("sb-babyzone");
        }
        if (this.cid == "toolstation") {
          document.body.classList.add("sb-toolstation");
        }
        if (this.cid == "euronics") {
          if (this.control_group == 0) {
            document.body.classList.add("sb-euronics-grid");
          }
          if (this.isMobile()) {
            this.insertafter = ".button.pBtn";
          }
          this.logo =
            "https://cdn.shopify.com/s/files/1/0550/5807/1748/files/euronics-logo_225x@2x.png?v=1615983991";
          this.maincolor = "#1e2d7d";
          this.parent = ".product-item";
          this.identifier = "a";
          this.attr = "href";
          this.detailsidentifier = ["url"];
          this.productdetails = ["body.template-product"];
          this.cartpage = ["body.template-cart"];
          this.homepage = ["body.template-index"];
          this.productgrid = ["body.template-collection,body.template-search"];
          this.insert = true;
          this.insertclass = "shopbox-find-similar";
          this.insertafter = ".product-item__info";
          this.similarembedselector = "#shopify-section-product-template";
          document.body.classList.add("sb-euronics");
        }
        if (this.cid == "designyard") {
          this.productgrid = ["body.tax-product_cat"];
          this.pricer = 50;
          this.$store.commit("SET_PRICER", this.pricer);
          document.body.classList.add("sb-designyard");
        }
        if (this.cid == "interfloradk") {
          this.language = "da";
          this.right = false;
          this.maincolor = "#1e2d7d";
          this.productgrid = [
            ".marketplace-interflora .category,.marketplace-interflora .search",
          ];
          this.similarembedselector = null;

          document.body.classList.add("sb-interfloradk");
        }
        if (
          this.cid == "interfloradk" &&
          [-1, 1, 2, 3].includes(this.control_flag) &&
          this.enabledOnPage("productgrid")
        ) {
          console.log("disable on grid");
          document.body.classList.add("sb-disable-grid-widget");
        }
        if (this.cid == "buildfourless") {
          this.recentembedselector = "#shopify-section-1613403092081c3b35";
          this.similarembedselector = ".product-section";

          document.body.classList.add("sb-build4less");
        }

        if (
          window.location.host == "tonykealys.com" ||
          window.location.host == "tonykealys.co.uk"
        ) {
          document.body.classList.add("sb-tk");
        }

        if (window.location.host == "www.abcschoolsupplies.ie") {
          document.body.classList.add("sb-abc");
        }
        if (window.location.host == "www.easons.com") {
          document.body.classList.add("sb-easons");
        }
        if (
          window.location.host == "www.expert.ie" ||
          window.location.host == "dev.expert.ie"
        ) {
          if (this.isKos) {
            this.similarembedselector = ".product.info.detailed";
          }

          document.body.classList.add("sb-expert");
        }
        if (window.location.host == "greenesshoes.com") {
          if (this.isKos) {
            this.similarembedselector = ".product.clearfix";
          }
          document.body.classList.add("sb-greenshoes");
        }
        if (window.location.host == "www.interflora.es") {
          document.body.classList.add("sb-interflora");
        }
        if (window.location.host == "stylecheat.com") {
          document.body.classList.add("sb-stylecheat");
        }
        if (window.location.host == "hanley.ie") {
          document.body.classList.add("sb-hanley");
        }

        this.checkEnabled();

        this.checkDetails();
        this.toggleRecentCTA();
        this.insertFindSimButtons();
        if (this.enabledOnPage("productgrid")) {
          this.observeProductGrid();
        } else {
          if (document.sbobserver) {
            document.sbobserver.disconnect();
          }
        }
        this.enableFilterListeners();
        // this.partnerCustomeridSet();
        // this.partnerDeviceidSet();
        this.magentoCartEvent();

        if (this.currencyelement) {
          this.observeCurrency(this.currencyelement);
          this.observeCurrencyMutation();

          // this.observeCurrency('#switcher-currency-trigger')
        }

        setTimeout(() => {
          // mageonto checkout & success page events

          if (window.location.href.indexOf("checkout") != -1) {
            this.isHidden = true;
          } else {
            this.isHidden = false;
          }
          if (window.location.href.indexOf("/checkout/onepage/success") != -1) {
            let successString = document.querySelector("body").outerHTML;
            this.$store.dispatch("emitEvent", {
              data: {
                page:
                  this.c_page + window.location.search ||
                  window.location.pathname + window.location.search,
                productid: successString,
                sbAction: "Order",
                site: this.site,
                source: "SuccessPage",
                uuid: this.uuid,
              },
              headers: {},
              type: "sbaction",
            });
          }
        }, 200);
        let currentPage;
        if (this.enabledOnPage("homepage")) {
          currentPage = "Homepage";
        } else if (
          this.enabledOnPage("productgrid") &&
          window.location.pathname != "/"
        ) {
          currentPage = "ProductGrid";
        } else if (this.enabledOnPage("productdetails")) {
          currentPage = "Details";
        } else {
          currentPage = "";
        }
        this.$store.dispatch("emitEvent", {
          data: {
            page:
              this.c_page + window.location.search ||
              window.location.pathname + window.location.search,
            productid: currentPage,
            sbAction: "Page",
            site: this.site,
            source: "PageLoad",
            uuid: this.uuid,
          },
          headers: {},
          type: "sbaction",
        });
        this.$store.dispatch("emitEvent", {
          data: {
            page:
              this.c_page + window.location.search ||
              window.location.pathname + window.location.search,
            productid: navigator.userAgent,
            sbAction: "DeviceString",
            site: this.site,
            source: "PageLoad",
            uuid: this.uuid,
          },
          headers: {},
          type: "sbaction",
        });
      }
      setTimeout(() => {
        if (this.control_group == 0) {
          if (
            this.enabledOnPage("productgrid") &&
            window.location.pathname != "/" &&
            !this.isMobile() &&
            this.cid != "buildfourless" &&
            this.cid != "interflora" &&
            this.cid != "interfloradk"
          ) {
            if (!this.abtest) {
              if (
                this.cid == "mccabespharmacy" &&
                document.querySelector(".brand-page-featured-products")
              ) {
                // console.log("no tutorial on this page");
              } else {
                this.startTour();
              }
            }
          }
        }
      }, 600);
    },
  },
  methods: {
    startTour(force) {
      let enableTour = false;
      if (!this.isKos && enableTour) {
        this.$refs.shopboxTour.startTour(force);
      }
    },
    closeAnyPanel() {
      let anyPanelOpen = this.panelList.find((panel) => this[panel]);
      console.log(anyPanelOpen);
      this.$store.commit("CLOSE_PANEL", anyPanelOpen.split("Open")[0]);
    },
    toggleRecent(payload) {
      this.$refs.recent.toggleRecent(payload);
    },
    togglePurchased(payload) {
      this.$refs.purchased.togglePurchased(payload);
    },
    toggleCrosssell(payload) {
      this.$refs.crosssell.toggleCrosssell(payload);
    },
    toggleSimilar(payload) {
      this.$refs.similar.toggleSimilar(payload);
    },
    toggleRecentCTA() {
      let recentCtaMsg = this.content[this.lang].cta.recent;
      if (this.isMobile() == true) {
        recentCtaMsg = this.content[this.lang].cta.recentMobile;
      } else {
        if (this.cid == "buildfourless") {
          recentCtaMsg = {
            heading: "You recently viewed the following products",
          };
        }
      }

      if (this.enabledOnPage("homepage") && this.control_group == 0) {
        // console.log(this.control_group);
        // console.log(this.enabledOnPage("homepage"));
        this.toggleRecent({
          toggle: false,
          reset: true,
          page: 1,
          force: false,
        });

        this.$store.commit("OPEN_CTA", {
          ...recentCtaMsg,
          timer: 10000,
          products: "recentProducts",
          action: "toggleRecent",
        });

        if (this.recentembedselector && this.killswitch) {
          this.embedRecentPanel(
            this.$store,
            this.maincolor,
            this.recentembedselector
          );
        }
      }
    },
    toggleCrosssellCTA() {
      this.toggleCrosssell({
        toggle: false,
        reset: true,
        force: false,
        page: 1,
      });
      this.$store.commit("OPEN_CTA", {
        heading: "Ofter bought together",
        timer: 30000,
        products: "crosssellProducts",
        action: "toggleCrosssell",
      });
    },
    getLSWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      const now = new Date();
      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      return item.value;
    },
    toggleSimilarCTA(sku) {
      let similarCtaMsg = {
        heading: this.content[this.lang].cta.similar.heading,
        timer: 8888000,
      };
      if (this.isMobile() == true) {
        similarCtaMsg = {
          heading: this.content[this.lang].cta.similarMobile.heading,
          timer: 20000,
        };
      }

      this.toggleSimilar({
        toggle: false,
        reset: true,
        force: false,
        page: 1,
        sku: sku,
      });
      if (this.getLSWithExpiry("sb-cta-similar-timeout") == null) {
        this.$store.commit("OPEN_CTA", {
          ...similarCtaMsg,
          products: "similarProducts",
          action: "toggleSimilar",
        });
      }
    },
    closePanels() {
      if (this.menuOpen) {
        this.$store.commit("CLOSE_PANEL_NO_EVENT", "menu");
      }
      if (this.recentOpen) {
        this.$store.commit("CLOSE_PANEL_NO_EVENT", "recent");
      }
      if (this.similarOpen) {
        this.$store.commit("CLOSE_PANEL_NO_EVENT", "similar");
      }
      if (this.crosssellOpen) {
        this.$store.commit("CLOSE_PANEL_NO_EVENT", "crosssell");
      }
      if (this.purchasedOpen) {
        this.$store.commit("CLOSE_PANEL_NO_EVENT", "purchased");
      }
      if (this.ctaOpen) {
        this.$store.commit("CLOSE_PANEL_NO_EVENT", "cta");
      }

      if (window.dndTour && window.dndTour.isActive()) {
        window.dndTour.cancel();
      }
    },
    checkEnabled() {
      let findsim =
        this.enabledOnPage("productdetails") +
        this.enabledOnPage("productgrid");

      this.$store.commit("SET_ENABLED", {
        key: "homepage",
        widget: "recent",
        value: this.enabledOnPage("homepage"),
      });
      this.$store.commit("SET_ENABLED", {
        key: "productgrid",
        widget: "similar",
        value: findsim >= 1 ? true : false,
      });
      this.$store.commit("SET_ENABLED", {
        key: "productgrid",
        widget: "dnd",
        value: this.enabledOnPage("productgrid"),
      });
      this.$store.commit("SET_ENABLED", {
        key: "cartpage",
        widget: "crosssell",
        value: this.enabledOnPage("cartpage"),
      });
    },
    checkDetails() {
      if (this.enabledOnPage("productdetails")) {
        window.addEventListener("scroll", this.trackScroll);
        let sku;
        if (this.detailsidentifier == "url") {
          let skuArr = window.location.pathname
            .split("?")[0]
            .split("/")
            .filter((x) => x != "");
          sku = skuArr[skuArr.length - 1]
            .replace(".html", "")
            .replace(/[^\w]/g, "")
            .replace(/[^\w]/g, "")
            .replace(/_/g, "");

          if (this.cid == "interflora") {
            sku = skuArr[skuArr.length - 1]
              .split("#")[0]
              .replace(".html", "")
              .replace(/[^\w]/g, "")
              .replace(/[^\w]/g, "")
              .replace(/_/g, "");
          }
        } else {
          if (this.detailsattr) {
            sku = document
              .querySelector(
                this.detailsidentifier
                  ? this.detailsidentifier
                  : this.identifier
              )
              .getAttribute(this.detailsattr);
          } else {
            sku = document.querySelector(
              this.detailsidentifier ? this.detailsidentifier : this.identifier
            ).innerText;
          }
        }

        this.$store.commit("UPDATE_PRODUCT_ID", sku);
        this.$store.dispatch("emitEvent", {
          data: {
            productid: sku,
            uuid: this.uuid,
            site: this.site,
          },
          headers: {},
          type: "details",
        });

        if (this.control_group == 0) {
          this.toggleSimilarCTA(sku);
        }

        // embed
        if (sku) {
          if (this.similarembedselector && this.control_group == 0) {
            if (this.killswitch) {
              this.embedSimilarPanel(
                this.$store,
                this.maincolor,
                sku,
                this.similarembedselector
              );

              if (this.cid == "buildfourless") {
                if (this.recentembedselector) {
                  this.embedRecentPanel(
                    this.$store,
                    this.maincolor,
                    ".sb-similar-panel"
                  );
                }
              }
            }
          }
        }
      }
    },
    updateUserGroups() {
      if (this.cid) {
        this.$store.commit("SET_CLIENT", this.cid);
      }
      const sb_v1_uuid = localStorage.getItem("shopbox_uuid");
      const sbAdmin = localStorage.getItem("shopboxAdmin");

      if (
        !this.uuid ||
        !this.control_flag ||
        !this.control_group ||
        !sessionStorage.isNewSession ||
        sb_v1_uuid ||
        (sbAdmin && this.control_group != 0)
      ) {
        let uuid;
        if (sb_v1_uuid) {
          uuid = localStorage.getItem("shopbox_uuid");
        } else {
          uuid = this.uuid || this.generateUuid();
        }
        var seed = uuid.split("-")[4];
        var rnd = seedrandom(seed);
        var randomNumber = Math.floor(rnd() * 10);
        let control_flag = this.control_flag || randomNumber;
        if (sbAdmin == true || sbAdmin == "true") {
          // console.log("sbadmin is true", sbAdmin);
          control_flag = -1;
        }
        this.$store.commit("UPDATE_UUID", uuid);
        this.$store.commit("SET_CONTROL_FLAG", control_flag);
        this.$store.dispatch("emitEvent", {
          data: {
            uuid: this.uuid,
            group: this.control_flag,
          },
          headers: {},
          type: "usergroup",
        });

        this.getDeviceType(this);

        sessionStorage.isNewSession = true;
      }

      if (sb_v1_uuid && sb_v1_uuid != this.uuid) {
        this.$store.commit("UPDATE_UUID", sb_v1_uuid);
      }
    },
    enableFilterListeners() {
      if (this.filters) {
        const parsedFilters = JSON.parse(this.filters);
        parsedFilters.forEach((filter) => {
          this.detectDetailsFilter(filter);
        });
      }
    },
    observeCurrencyMutation() {
      setTimeout(() => {
        if (this.cid == "fitpinkfitness") {
          let q = document.querySelector(".buckscc-select-styled");
          let mList = q,
            options = {
              childList: true,
            };
          document.sbcobserver = new MutationObserver(this.fpfcb);
          document.sbcobserver.observe(mList, options);
        }
      }, 600);
    },
    fpfcb(mutations) {
      for (let mutation of mutations) {
        console.log(mutation);
        this.observeCurrency(this.currencyelement);
      }
    },
    insertFindSimButtons() {
      if (
        (this.insert == "true" || this.insert == true) &&
        this.enabledOnPage("productgrid") &&
        this.killswitch &&
        this.control_group == 0 &&
        this.itfdk
      ) {
        let parents = [];

        if (this.parent.toString().indexOf(",")) {
          parents = [...this.parent.split(",")];
        } else {
          parents.push(...this.parent);
        }
        parents.forEach((p) => {
          const products = document.querySelectorAll(`${p}`);

          const searchConfig = {
            reach: this.reach,
            parent: p,
            className: this.identifier,
            attr: this.attr,
          };
          products.forEach((product) => {
            let productSku = this.returnSku(product, searchConfig);
            const sbbtn = document.createElement("div");
            sbbtn.setAttribute("data-sku", productSku);
            sbbtn.classList.add(...["sb-findsim-v2", this.insertclass]);
            console.log(this.cid, this.control_flag);
            sbbtn.textContent = this.content[this.lang].buttons.similar;

            sbbtn.addEventListener("click", (e) => {
              e.stopPropagation();
              e.stopImmediatePropagation();
              this.toggleSimilar({
                sku: productSku,
                toggle: true,
                reset: true,
                force: true,
                page: 1,
              });
              this.$store.dispatch("emitEvent", {
                data: {
                  page: this.c_page,
                  productid: productSku,
                  sbAction: `FindSimilar`,
                  site: this.site,
                  source: "EmbededButtons",
                  uuid: this.uuid,
                },
                headers: {},
                type: "sbaction",
              });
            });

            product.querySelector(".sb-findsim-v2");
            if (!product.querySelector(".sb-findsim-v2")) {
              if (this.cid == "interfloradk") {
                product.after(sbbtn);
              } else {
                if (
                  this.cid == "meagherspharmacy" &&
                  !product.querySelector(this.insertafter) &&
                  product.querySelector(".snize-thumbnail")
                ) {
                  product.querySelector(".snize-view-link").after(sbbtn);
                } else {
                  product.querySelector(this.insertafter).after(sbbtn);
                }
              }
            }
          });
        });
      }
    },
    observeProductGrid() {
      let parents = [];
      let vm = this;
      if (this.parent.toString().indexOf(",")) {
        parents = [...this.parent.split(",")];
      } else {
        parents.push(...this.parent);
      }
      let q;

      if (!document.querySelector(parents[0]) && parents.length > 1) {
        q = document.querySelector(parents[1]).parentNode;
      } else {
        q = document.querySelector(parents[0]).parentNode;
      }

      let mList = q,
        options = {
          childList: true,
        };
      if (this.cid == "interflora") {
        setInterval(() => {
          vm.insertFindSimButtons();
        }, 5000);
      }
      if (this.cid == "buildfourless") {
        setInterval(() => {
          vm.insertFindSimButtons();
        }, 1600);
      }
      if (this.cid == "meagherspharmacy") {
        setInterval(() => {
          vm.insertFindSimButtons();
        }, 2400);
      }
      document.sbobserver = new MutationObserver(mCallback);

      function mCallback(mutations) {
        for (let mutation of mutations) {
          if (mutation.type === "childList") {
            vm.insertFindSimButtons();
          }
        }
      }

      document.sbobserver.observe(mList, options);
    },
    partnerCustomeridSet() {
      const partneridResp = localStorage.getItem("xtremepush.data")
        ? JSON.parse(localStorage.getItem("xtremepush.data"))
        : false;
      // // console.log(partneridResp);
      // // console.log("test cid", partneridResp["subscription"]);
      const partneridExists =
        partneridResp && partneridResp.user_id ? partneridResp.user_id : false;
      // // console.log(partneridExists);
      if (partneridExists) {
        this.$store.dispatch("fetchPartnerCustomerId", {
          data: {
            uuid: this.uuid,
            partner_cid: String(partneridResp.user_id),
          },
        });
      }
    },
    partnerDeviceidSet() {
      const partneridResp = localStorage.getItem("xtremepush.data")
        ? JSON.parse(localStorage.getItem("xtremepush.data"))
        : false;
      // // console.log(partneridResp);
      // // console.log("test did", partneridResp["subscription"]);
      const partneridExists =
        partneridResp && partneridResp.id ? partneridResp.id : false;
      // // console.log(partneridExists);
      if (partneridExists) {
        this.$store.dispatch("fetchPartnerDeviceId", {
          data: {
            uuid: this.uuid,
            partner_did: String(partneridResp.id),
          },
        });
      }
    },
    setProductBannerData() {
      if (this.productbanerdata) {
        this.$store.commit(
          "SET_BANNER_DATA",
          JSON.parse(this.productbanerdata)
        );
      } else {
        this.$store.commit("SET_BANNER_DATA", null);
      }
    },
    magentoCartEvent() {
      let data;
      if (this.cid == "mcmahons") {
        data = {
          body: "body.checkout-cart-index",
          productSelector: ".cart-table tbody tr",
          skuSelector: '.product-cart-sku"',
          skuStrip: 5,
          priceSelector: '.product-cart-price[data-rwd-tax-label="Incl. Tax"]',
          priceStrip: 1,
          quantitySelector: ".input-text.qty",
        };
      } else if (
        this.cid == "the-irish-store" ||
        this.cid == "the-irish-store-uk"
      ) {
        data = {
          body: "body.checkout-cart-index",
          productSelector: ".cart.item",
          skuSelector: ".cart-item-sku",
          skuStrip: 6,
          priceSelector: ".price-including-tax .price",
          priceStrip: 1,
          quantitySelector: ".input-text.qty",
        };
      } else if (this.cid == "expert__disabled") {
        data = {
          body: "body.checkout-cart-index",
          productSelector: ".cart.item",
          skuSelector: ".product-sku",
          skuStrip: 12,
          priceSelector: ".price-including-tax .price",
          priceStrip: 1,
          quantitySelector: ".input-text.qty",
        };
      } else if (this.cid == "did") {
        data = {
          body: "body.checkout-cart-index",
          productSelector: ".cart-table tbody tr",
          skuSelector: ".td-product-name  p",
          skuStrip: 5,
          priceSelector: ".cart-price .price",
          priceStrip: 1,
          quantitySelector: ".input-text.qty",
        };
      }
      if (
        this.cid == "mcmahons" ||
        this.cid == "did" ||
        this.cid == "the-irish-store" ||
        this.cid == "the-irish-store-uk"
      ) {
        let cartBody = document.querySelector(data.body);
        if (cartBody && cartBody.querySelectorAll(data.productSelector)) {
          let cartProducts = Array.from(
            cartBody.querySelectorAll(data.productSelector)
          );

          let cartProductsData = [];
          for (let productElement of cartProducts) {
            let sku = productElement
              .querySelector(data.skuSelector)
              .innerText.substring(data.skuStrip);
            let price = productElement
              .querySelector(data.priceSelector)
              .innerText.substring(data.priceStrip);
            let quantity = productElement.querySelector(
              data.quantitySelector
            ).value;
            cartProductsData.push({
              productid: sku,
              price: price,
              quantity: quantity,
            });
          }
          this.$store.dispatch("emitEvent", {
            data: {
              items: cartProductsData,
              site: this.site,
              uuid: this.uuid,
            },
            headers: {},
            type: "cart",
          });
        }
      }
    },
    trackScroll() {
      this.windowTop = window.scrollY;
    },
    initABTest() {
      if (this.cid == "meagherspharmacy" || this.cid == "did") {
        if (
          this.control_flag == 1 ||
          this.control_flag == 2 ||
          this.control_flag == 3
        ) {
          this.paneltest = true;
        } else {
          this.paneltest = false;
        }
      }
      if (
        this.cid == "stylecheat" ||
        this.cid == "interflora" ||
        this.cid == "did"
      ) {
        if (
          this.control_flag == 1 ||
          this.control_flag == 2 ||
          this.control_flag == 3
        ) {
          // console.log("123 ab");

          if (
            !this.enabledOnPage("productdetails") &&
            !this.enabledOnPage("homepage")
          ) {
            this.abtest = true;
          } else {
            this.abtest = false;
          }
          if (this.enabledOnPage("homepage")) {
            this.dndtest = true;
          } else {
            this.dndtest = false;
          }
        }
        if (this.cid == "did" || this.cid == "interflora") {
          // console.log("did itf  ab");
          if (
            !this.enabledOnPage("productdetails") &&
            !this.enabledOnPage("homepage")
          ) {
            this.abtest = true;
          } else {
            this.abtest = false;
          }
          if (this.enabledOnPage("homepage")) {
            this.dndtest = true;
          } else {
            this.dndtest = false;
          }
        }

        // REMOVE COMMENT TO ENABLE ITF ABTEST
        this.initITFABTest();
      }
    },
    initITFABTest() {
      if (this.cid == "interflora") {
        if (this.enabledOnPage("productdetails")) {
          if (this.control_flag == 4 || this.control_flag == 5) {
            this.abtestitf = true;
            // console.log(" itf  4 5");
          } else {
            this.abtestitf = false;
            // console.log("no itf  4 5");
          }
        } else {
          // console.log("no itf  4 5");

          this.abtestitf = false;
        }
      }
    },
    setSentryVars() {
      Sentry.setTag("client_id", this.cid);
    },
  },

  mounted() {
    // prevent default drag&drop events
    document.addEventListener("dragover", function (e) {
      e.preventDefault();
    });
    if (this.cid == "interfloradk") {
      this.language = "da";
      this.right = false;
      this.maincolor = "#1e2d7d";
      document.body.classList.add("sb-interfloradk");
    }
    if (
      this.cid == "interfloradk" &&
      [-1, 1, 2, 3].includes(this.control_flag) &&
      this.enabledOnPage("productgrid")
    ) {
      console.log("disable on grid");
      document.body.classList.add("sb-disable-grid-widget");
    }
    if (this.cid == "buildfourless") {
      document.body.classList.add("sb-build4less");
    }
    this.setSentryVars();
    this.initABTest();
    if (this.cid == "silverdluxe") {
      this.decimalcomma = true;
    }
    if (this.cid == "euronics") {
      if (this.control_group == 0) {
        document.body.classList.add("sb-euronics-grid");
      }
      if (this.isMobile()) {
        this.insertafter = ".button.pBtn";
      }
      this.logo =
        "https://cdn.shopify.com/s/files/1/0550/5807/1748/files/euronics-logo_225x@2x.png?v=1615983991";
      this.maincolor = "#1e2d7d";
      this.parent = ".product-item";
      this.identifier = "a";
      this.attr = "href";
      this.detailsidentifier = ["url"];
      this.productdetails = ["body.template-product"];
      this.cartpage = ["body.template-cart"];
      this.homepage = ["body.template-index"];
      this.productgrid = ["body.template-collection,body.template-search"];
      this.insert = true;
      this.insertclass = "shopbox-find-similar";
      this.insertafter = ".product-item__info";
      this.similarembedselector = "#shopify-section-product-template";
      document.body.classList.add("sb-euronics");
    }
    // Check if mobile
    this.$store.commit("CHECK_MOBILE", this.isMobile());
    this.$store.commit("SET_CURRENCY", this.currency);
    this.$store.commit("SET_DECIMALCOMMA", this.decimalcomma);
    this.$store.commit("SET_PRICER", this.pricer);
    this.$store.commit("SET_PORTRAIT", this.portrait);

    if (
      this.cid == "fairfashionista" ||
      this.cid == "fairfashionistadk" ||
      this.cid == "fairfashionistase"
    ) {
      this.detailsattr = null;
      this.detailsidentifier = "url";
      this.identifier = "a";
      this.attr = "href";
      document.body.classList.add("sb-fairfashionista");
    }
    // Create uuid for the user if not present in localstorage
    this.setProductBannerData();
    this.setShopboxAdmin();
    // Track route changes
    this.$store.commit("RESET_C_PAGE");
    this.routerChange(this);
    // Send device type to backend
    this.updateUserGroups();
    //  window.onhashchange = this.closePanels();
    // let vm = this;
    window.addEventListener("beforeunload", this.closePanels);

    // setInterval(function () {
    // sessionStorage.removeItem("isNewSession");
    // vm.updateUserGroups();
    // }, 86400000);
  },
};
</script>

<style scoped>
#shopbox/deep/ .shopbox-main {
  font-size: 14px !important;
  --shopbox-text: #353535;
  --shopbox-text-light: #fff;
  /* --shopbox-main: #083d77; */
  --shopbox-secondary: #284b63;
  --shopbox-background-dark: #d9d9d9;
  --shopbox-background-light: #fdfdfd;
}
#shopbox/deep/ * {
  font-family: sans-serif;
  box-sizing: border-box;
  text-decoration: none !important;
  padding: 0;
  margin: 0;
}
#shopbox/deep/.sb-expand {
  position: absolute;
  bottom: 0%;
  transform: translateY(50%);
  border-radius: 50%;
  background: #fff;
  width: 28px;
  height: 28px;
  box-shadow: 0 1px 4px 0 rgba(117, 141, 166, 0.3142);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  line-height: 16px;
  right: -14px;
}
#shopbox/deep/ a {
  text-decoration: none;
  color: inherit;
}
#shopbox /deep/.emoji {
  font-size: 1.6em;
}
.hs .sb-item .sb-findsim-v2 {
  z-index: 2 !important;
}
@media (max-width: 640px) {
  #shopbox /deep/.sb-panel:not(.sb-cta) {
    max-width: 100vw !important;
    bottom: 0px !important;
    left: 0px !important;
    height: 100%;
    z-index: 2147483647;
  }
  #shopbox .sb-menu--btn_group {
    bottom: 14px;
  }
  #shopbox .sb-menu--items {
    height: auto !important;
    min-height: 320px !important;
  }
  #shopbox /deep/ .sb-menu--items .sb-close {
    display: flex;
    color: #fff;
  }
  #shopbox /deep/.sb-item {
    flex-basis: 100%;
    margin-bottom: 16px;
    max-height: 30vh;
    flex-direction: row;
  }
  #shopbox /deep/.sb-item .sb-item-img {
    margin-right: 8px;
  }

  #shopbox/deep/.sb-product-controls {
    right: 16px;
    top: unset;
    bottom: 4px;
    transform: none;
    width: 40%;
    border-radius: 12px;
    display: none !important;
  }
  #shopbox/deep/.sb-prev {
    left: 16px;
  }

  #shopbox/deep/.sb-products--grid {
    justify-content: center;
    flex-wrap: wrap;
    overflow: hidden;
    height: calc(100% - 20px) !important;
    padding-bottom: 42px;
    overflow-y: scroll;
    margin-top: 20px;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
  }

  #shopbox .sb-products--grid::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }
  #shopbox /deep/.sb-products--grid svg {
    transform: scaleY(3) scaleX(4.2);
  }
  #shopbox/deep/ .sb-similar .sb-close,
  #shopbox/deep/ .sb-recent .sb-close {
    font-size: 18px;
  }

  /* // TODO */
  #shopbox/deep/ .sb-cta {
    width: 200px;
  }
  #shopbox/deep/ .sb-cta.ctaPortrait {
    bottom: 84px !important;
  }
  #shopbox/deep/ .sb-cta .shopbox-header h4 {
    font-size: 14px !important;
  }
  #shopbox/deep/ .sb-cta hr {
    margin: 4px auto;
  }
  #shopbox/deep/ .sb-cta .shopbox-header * {
    font-size: 16px !important;
  }
  #shopbox/deep/ .sb-cta li:nth-of-type(n + 3) {
    display: none !important;
  }
  #shopbox/deep/ .sb-cta img {
    display: block;
    margin: 0 auto;
    width: 80px !important;
    height: 80px !important;
  }
}

#shopbox .shopbox-abtest .sb-menu--btn_group {
  opacity: 0 !important;
  height: 0 !important;
  overflow: hidden !important;
}
#shopbox/deep/ .shopbox-dndtest .sb-btn--sm {
  display: none;
  opacity: 0 !important;
  height: 0 !important;
  width: 0 !important;
  overflow: hidden !important;
}

#shopbox .shopbox-abtest .sb-callout {
  display: none !important;
  opacity: 0 !important;
}

#shopbox .shopbox-abtestsc .sb-menu--btn_group,
#shopbox .shopbox-abtestsc .sb-cta {
  display: none !important;
  opacity: 0 !important;
}
#shopbox/deep/ .shopbox-main.shopbox-abtestsc .sb-similar {
  bottom: 0 !important;
  left: 14px !important;
}
#shopbox/deep/ .shopbox-right.shopbox-abtestsc .sb-similar {
  bottom: 0 !important;
  right: 14px !important;
  left: unset !important;
}

#shopbox .shopbox-abtestitf {
  display: none !important;
  opacity: 0 !important;
}

#shopbox/deep/ .shopbox-main.shopbox-abtest .sb-similar {
  bottom: 0 !important;
  left: 14px !important;
}
#shopbox/deep/ .shopbox-right.shopbox-abtest .sb-similar {
  bottom: 0 !important;
  right: 14px !important;
  left: unset !important;
}
@media (max-width: 640px) {
  #shopbox/deep/ .shopbox-main.shopbox-abtest .sb-similar {
    bottom: 0 !important;
    left: 0px !important;
  }
  #shopbox/deep/ .shopbox-right.shopbox-abtest .sb-similar {
    bottom: 0 !important;
    right: 0px !important;
    left: unset !important;
  }
}
</style>
<style>
.sb-findsim-v2,
.shopbox-find-similar {
  cursor: pointer !important;
}
.sb-greenshoes .sb-findsim-v2 {
  background-color: transparent;
  border: 1px solid #e3e3e3;
  color: #84bd00;
  cursor: pointer;
  height: auto;
  line-height: 2.5;
  margin: 0 auto 15px;
  min-height: 0;
  transition: all 0.25s ease-in-out;
  width: 80%;
}
.sb-greenshoes .sb-findsim-v2:hover {
  background-color: #ebffbd;
  color: #000;
}
.sb-tk .sb-findsim-v2.sb-findsim {
  background-color: transparent;
  border: 1px solid #e3e3e3;
  color: #1770e4;
  cursor: pointer;
  height: auto;
  line-height: 2.5;
  margin: 0 auto 15px;
  min-height: 0;
  transition: all 0.25s ease-in-out;
  width: 80%;
}

.sb-tk .sb-findsim-v2.sb-findsim:hover {
  background: #1770e4;
  color: #fff;
}
.sb-tk .shopbox-find-similar:hover {
  background: #1770e4 !important;
  color: #fff !important;
}
.sb-tis .sb-findsim-v2.shopbox-find-similar {
  background-image: none;
  background: #fff;
  border: 1px solid #a9b089;
  color: #444;
  display: flex;
  text-align: center;
  cursor: pointer;
  padding: 6px 12px;
  justify-content: center;
  margin-bottom: 4px;
}
.sb-tis .sb-findsim-v2.shopbox-find-similar:hover {
  color: #fff;
  background: #a9b089;
}
.sb-tis .products.list .sb-findsim-v2.shopbox-find-similar {
  max-width: 160px;
}

.sb-abc .shopbox-find-similar {
  max-width: 80%;
  border: 1px solid #0099a2;
  border-radius: 3px;
  padding: 5px 0;
  margin: 10px auto;
  transition: all 0.2s ease-out;
  cursor: pointer;
}
.sb-abc .shopbox-find-similar:hover {
  color: #fff;
  background: #0099a2;
}
.sb-expert .shopbox-find-similar {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #eb6a0a;
  border-radius: 2px;
  padding: 6px 0;
  margin: 4px auto;
  transition: all 0.2s ease-out;
  cursor: pointer;
  position: relative;
  z-index: 23232;
}
.sb-expert .shopbox-find-similar:hover {
  color: #fff;
  background: #eb6a0a;
}
.sb-interflora .shopbox-find-similar {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
  margin: 4px auto;
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.sb-interfloradk #shopbox .btn-wrap .product-btn {
  margin-left: 4px !important;
  margin-right: 4px !important;
  margin-bottom: 4px !important;
  height: 20px;
}

.sb-disable-grid-widget.sb-interfloradk .sb-callout {
  display: none !important;
}
.sb-disable-grid-widget.sb-interfloradk .sb-menu--btn_group {
  display: none !important;
}
.sb-disable-grid-widget.sb-interfloradk .sb-similar {
  bottom: 26px !important;
  left: 26px !important;
}
.sb-interfloradk .shopbox-find-similar {
  text-align: center;
  font-family: Omnes, sans-serif;
  font-weight: 500;
  text-decoration: underline;
  margin-top: 10px;
  position: relative;
  z-index: 99;
  margin: -20px auto 0px;
}
.sb-interfloradk .category .item-list li,
.sb-interfloradk .search .item-list li {
  flex-wrap: wrap;
}

.sb-interfloradk .shopbox-main .price {
  font-family: "Begum", serif !important;
  color: #000;
}

.sb-interfloradk #shopbox .shopbox-header {
  background: #000;
}
.sb-interfloradk .sb-similar-panel .price {
  color: #000;
  font-family: "Begum", serif;
}
.sb-interfloradk .sb-item--details a {
  text-decoration: none !important;
}
.sb-interflora .products-list-carousel .shopbox-find-similar {
  display: none;
}
.sb-interfloradk #shopbox .ctaPortrait {
  border-radius: 14px !important;
  overflow: visible !important;
}
.sb-interfloradk #shopbox .ctaPortrait .sb-heading {
  display: none !important;
}
.sb-interfloradk #shopbox .ctaPortrait .sb-close {
  border-radius: 10px !important;
  top: -40px !important;
  box-shadow: 0 1px 6px 0 rgba(117, 141, 166, 0.45) !important;
  right: 2px !important;
}
.sb-interfloradk #shopbox .sb-item {
  box-shadow: none !important;
  min-width: 30%;
}
.sb-interfloradk #shopbox .sb-item .sb-price-wraper {
  min-height: 2px !important;
}
.sb-interfloradk #shopbox .shopbox-right .sb-cta {
  right: 24px !important;
}
.sb-interfloradk #shopbox .shopbox-right .sb-menu--btn_group {
  right: 18px !important;
}
.sb-interfloradk #shopbox .product-btn.btn-secondary {
  position: relative;
}
.sb-interfloradk #shopbox .sb-product-controls {
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
}
.sb-interfloradk #shopbox .product-btn:hover {
  transform: none !important;
  box-shadow: none !important;
}
.sb-interfloradk #shopbox .product-btn.btn-secondary:after {
  content: "";
  display: block;
  position: absolute;
  right: -6px;
  height: 90%;
  width: 1px;
  background: #ddd;
}
.sb-interfloradk #shopbox .sb-products--grid {
  height: 274px;
}
.sb-interfloradk #shopbox .product-btn {
  border: none !important;
  background: none !important;
  color: #cfb66b !important;
  font-family: "Omnes";
  font-weight: 600 !important;
}
.sb-interfloradk #shopbox .sb-recent .sb-heading,
.sb-interfloradk #shopbox .sb-similar .sb-heading {
  display: none !important;
}
.sb-interfloradk #shopbox .sb-btn--primary svg path {
  fill: #fff !important;
}
.sb-interfloradk #shopbox .sb-btn--primary {
  border-radius: 10px !important;
  padding: 10px !important;
}
.sb-interfloradk #shopbox .sb-cta {
  animation: none;
}
.sb-interfloradk #shopbox .sb-menu--btn {
  background-color: #cfb66b !important;
}
@media (max-width: 640px) {
  .sb-interfloradk #shopbox *,
  .sb-interfloradk #shopbox .shopbox-right .sb-menu--btn_group,
  .sb-interfloradk .shopbox-find-similar {
    display: none !important;
  }
}
.sb-interfloradk #shopbox .lastPageWarning {
  font-size: 13px !important;
}
.sb-interfloradk #shopbox .sb-item img {
  object-fit: cover !important;
  width: 200px;
  height: 178px;
  margin-bottom: 4px !important;
  border-radius: 10px !important;
}
.sb-interfloradk #shopbox .sb-panel.sb-recent,
.sb-interfloradk #shopbox .sb-panel.sb-similar {
  padding-bottom: 0px !important;
}

.sb-interfloradk #shopbox .btn-wrap {
  align-items: flex-end;
  margin: 0;
}
.sb-interfloradk #shopbox .sb-menu--item {
  background: #fff !important;
  box-shadow: 0 1px 6px 0 rgba(117, 141, 166, 0.3) !important;
  padding: 1.2em;
  filter: none;
}
.sb-interfloradk #shopbox .sb-menu--items .sb-close {
  display: flex !important;
  color: #000 !important;
}
.sb-interfloradk #shopbox .with-logo .shopbox-header {
  background: #fff !important;
  justify-content: center !important;
}
.sb-interfloradk #shopbox .with-logo .shopbox-header img {
  display: none !important;
}
.sb-interfloradk #shopbox .sb-notification--dot {
  left: -2px;
  top: -2px;
  width: 14px;
  height: 14px;
}
.sb-interfloradk #shopbox .branding {
  display: none;
}
.sb-interfloradk #shopbox .with-logo .shopbox-header h4 {
  font-family: "Begum", serif !important;
  font-weight: bold;
}
.sb-interfloradk #shopbox .with-logo .shopbox-header h4,
.sb-interfloradk #shopbox .with-logo .shopbox-header span {
  color: #000 !important;
}
.sb-interfloradk .sb-menu--btn_group,
.sb-interfloradk .sb-panel,
.sb-interfloradk .sb-callout {
  transform: translateY(-26px) !important;
}
.sb-interflora .eb-article-header {
  max-height: 130px;
}
.sb-stylecheat .shopbox-find-similar {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f2dace !important;
  border-radius: 2px;
  padding: 6px 0;
  margin: 4px auto;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #000;
}
.sb-stylecheat .shopbox-find-similar:hover {
  color: #000 !important;
  background: #f2dace !important;
}
.sb-stylecheat #shopbox .with-logo img,
.sb-hanley #shopbox .with-logo img {
  filter: invert(1) !important;
}
.sb-hanley .sb-emoji {
  display: none !important;
}
.sb-build4less .sb-emoji {
  display: none !important;
}
.sb-osullivanspharmacy .sb-emoji {
  display: none !important;
}
.sb-mccabespharmacy .sb-emoji {
  display: none !important;
}
.sb-hanley .shopbox-find-similar {
  max-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000;
  border-radius: 2px;
  padding: 4px 0;
  margin: 0 auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #000;
  z-index: 14 !important;
}
.sb-hanley .shopbox-find-similar:hover {
  color: #fff;
  background: #000;
}
.sb-easons .sb-findsim-v2 {
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid #44b7e3;
  font-size: 16px;
  color: #44b7e3;
  font-family: avenir-Heavy, arial, sans-serif;
  transition: all 0.3s ease-in;
  border-radius: 3px;
  margin: auto;
  padding: 8px 10px !important;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
}
.sb-easons .sb-findsim-v2:hover {
  background: #44b7e3;
  color: #fff;
}
.sb-easons .show-list .sb-findsim-v2 {
  margin-left: 4px;
  margin-right: 4px;
  width: 148px !important;
  float: left;
}
.sb-easons .eproduct-item:not(.show-list):not(.slick-slide) .sb-findsim-v2 {
  width: 148px !important;
  float: none;
}
.sb-silverdluxe #shopbox .similarCta {
  animation: none !important;
}
.sb-silverdluxe .sb-findsim-v2 {
  transition: none !important;
  transform: translateY(-35px) !important;
  transition: none !important;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000;
  border-radius: 2px;
  padding: 4px 0;
  cursor: pointer;
  max-width: 90%;
  color: #000;
  margin: 0 auto;
  font-family: inherit;
  font-size: inherit;
  transition: background 200ms ease;
}
.sb-silverdluxe .hs .sb-findsim-v2 {
  transform: none !important;
}

.sb-silverdluxe .sb-findsim-v2:hover {
  color: #fff;
  background-color: #000;
}
.sb-silverdluxe #shopbox .sb-clamp > h4 {
  font-weight: bold;
  font-family: "Open Sans", sans-serif !important;
  font-weight: 300 !important;
}
.sb-silverdluxe .hs .sb-clamp > h1 {
  font-family: "Open Sans", sans-serif !important;
  font-weight: 300 !important;
  text-align: center !important;
}
.sb-silverdluxe #shopbox .price,
.sb-silverdluxe .hs .price {
  font-weight: 300 !important;
  font-size: 1rem !important;
  text-align: center;
}
@media (min-width: 768px) {
  .template-product.sb-silverdluxe .sb-menu--btn_group,
  .template-product.sb-silverdluxe .sb-panel,
  .template-product.sb-silverdluxe .sb-callout {
    transform: translateY(-50px) !important;
  }
}
@media (max-width: 768px) {
  .sb-build4less .sb-btn--sm,
  .sb-build4less .sb-callout {
    display: none !important;
    opacity: 0 !important;
  }
}
/* @media (min-width: 768px) {
  .sb-build4less .sb-menu--btn_group,
  .sb-build4less .sb-panel,
  .sb-build4less .sb-callout {
    transform: translateY(-70px) !important;
  }
} */
.sb-build4less .sb-recent-panel,
.sb-build4less .sb-similar-panel {
  max-width: 1200px !important;
  background: #fff !important;
}
.sb-build4less .hs .sb-item a {
  cursor: pointer;
}
.sb-build4less .hs {
  padding-top: 10px !important;
}
.sb-build4less .hs .sb-item .sb-item--details {
  width: 100%;
}
.sb-build4less .sb-recent-panel .branding,
.sb-build4less .sb-similar-panel .branding,
.sb-build4less .sb-menu--items .branding {
  opacity: 0;
}
.sb-build4less .hs .sb-item {
  box-shadow: 0 1.5px 3px 0 rgb(0 0 0 / 25%), 0 -1.5px 3px rgb(0 0 0 / 25%) !important;
}
.sb-build4less #shopbox .price {
  font-family: "Poppins", sans-serif !important;
  font-weight: bold !important;
  font-size: 14px !important;
  align-items: center !important;
}

.sb-build4less .hs .price {
  font-size: 15px !important;
  font-family: "Poppins", sans-serif !important;
  font-weight: bold !important;
  font-size: 14px !important;
  align-items: center !important;
}
.sb-build4less .sb-recent-panel .sb-item:nth-of-type(n + 9),
.sb-build4less .sb-similar-panel .sb-item:nth-of-type(n + 9) {
  display: none !important;
}
.sb-build4less .sb-findsim-v2 {
  max-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #54bbc4 !important;
  border-radius: 2px;
  padding: 4px 0;
  margin: 0 auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #54bbc4 !important;
  position: relative;
  z-index: 13232 !important;
}
.sb-build4less .sb-findsim-v2:hover {
  background: #54bbc4 !important;
  color: #fff !important;
}

.sb-babyzone .sb-findsim-v2 {
  max-width: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #9fb8ad;
  border-radius: 2px;
  padding: 4px 0;
  margin: 0 auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #9fb8ad;
  position: relative;
  z-index: 13232 !important;
}
.sb-babyzone .sb-findsim-v2:hover {
  background: #9fb8ad;
  color: #fff;
}
.sb-mccabespharmacy .sb-findsim-v2 {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #184038;
  border-radius: 2px;
  padding: 4px 0;
  margin: 4px auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #184038;
  position: relative;
  z-index: 13232 !important;
}
.sb-mccabespharmacy .hs .sb-findsim-v2 {
  z-index: 2 !important;
}
.sb-mccabespharmacy .sb-item-img {
  width: 100px;
  height: 100px;
  overflow: hidden;
}
.sb-mccabespharmacy #shopbox .sb-cta li {
  overflow: hidden;
}
.sb-mccabespharmacy .hs .sb-item > a {
  height: 140px;
  overflow: hidden;
  width: 140px;
}
.sb-mccabespharmacy .hs .sb-item img {
  transform: scale(1.8);
}
.sb-mccabespharmacy #shopbox .sb-cta img {
  transform: scale(1.8);
}
.sb-mccabespharmacy .sb-item-img img {
  transform: scale(1.8);
}
@media (max-width: 768px) {
  .sb-mccabespharmacy .sb-item-img {
    width: 150px;
    height: 150px;
  }
}

.sb-mccabespharmacy .sb-findsim-v2:hover {
  background: #184038;
  color: #fff;
}
.sb-mccabespharmacy .hs .price {
  font-size: 1.6rem !important;
}
.sb-meagherspharmacy #shopbox .ctaPortrait li {
  height: 45px;
  display: flex;
}
.sb-meagherspharmacy #shopbox .with-logo .shopbox-header img {
  margin-bottom: 0 !important;
}
.sb-meagherspharmacy .hs .btn-wrap,
.sb-meagherspharmacy .hs .sb-item--details {
  width: 100% !important;
}
.sb-meagherspharmacy .hs .sb-clamp > h1 {
  height: 2.5rem !important;
}
.sb-meagherspharmacy #shopbox .ctaPortrait .shopbox-header h2 {
  color: #25303b !important;
}
.sb-meagherspharmacy .sb-findsim-v2 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  border: 1px solid #25303b;
  border-radius: 2px;
  padding: 4px 0;
  margin: 4px auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #fff !important;
  background: #25303b;
  position: relative;
  z-index: 13232 !important;
}
.sb-meagherspharmacy .hs .sb-findsim-v2,
.sb-meagherspharmacy .snize-product .sb-findsim-v2 {
  z-index: 2 !important;
}
.sb-meagherspharmacy .sb-findsim-v2:hover {
  color: #25303b !important;
  background: #fff;
}
.sb-designyard .hs .sb-item--details h1,
.sb-designyard #shopbox .sb-item--details h4 {
  font-weight: 700 !important;
  text-transform: uppercase !important;
}
.sb-designyard #shopbox .price,
.sb-designyard .sb-item--details .price {
  font-weight: normal !important;
}
.sb-designyard .sb-item--details {
  text-align: left;
}
.sb-designyard .sb-findsim-v2 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  border: 1px solid #000;
  border-radius: 2px;
  padding: 4px 0;
  margin: 4px auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #000;
  position: relative;
  z-index: 13232 !important;
}
.sb-designyard .sb-findsim-v2:hover {
  background: #000;
  color: #fff;
}
.sb-designerexchange .sb-findsim-v2 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  border: 1px solid #000;
  border-radius: 2px;
  padding: 4px 0;
  margin: 4px auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #000;
}
.sb-designerexchange .sb-findsim-v2:hover {
  background: #000;
  color: #fff;
}
.sb-toolstation .sb-findsim-v2 {
  text-transform: uppercase;
  cursor: pointer;
  width: 100%;
  background: #19941d;
  color: #fff;
  border-radius: 40px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 8px;
  font-size: 16px;
  margin: 0 4px;
}
.sb-toolstation .sb-findsim-v2:hover {
  background: #126814;
}

.sb-fairfashionista .sb-findsim-v2 {
  display: flex;
  align-items: center;
  width: 80%;
  justify-content: center;
  border: 1px solid #54595f;
  border-radius: 2px;
  padding: 4px 0;
  margin: 4px auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #54595f;
}
.sb-fairfashionista .sb-findsim-v2:hover {
  color: #fff;
  background: #ff3399;
  border-color: #ff3399;
}
.sb-fitpinkfitness-currency .grid-product .swatch-wrap {
  padding-bottom: 4px !important;
}
.sb-fitpinkfitness-currency .buckscc-floating-box {
  display: none;
  /* opacity: 1; */
}
.sb-fitpinkfitness #shopbox .sb-item {
  min-width: 27%;
}
.sb-fitpinkfitness .sb-price-wraper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
}
.sb-fitpinkfitness .sb-price-wraper span > span {
  font-size: 14px !important;
  margin-right: 4px !important;
}
.sb-fitpinkfitness .sb-price-wraper span {
  font-size: 0;
  font-weight: 700;
}
.sb-fitpinkfitness .sb-price-red {
  color: #000;
}
.sb-fitpinkfitness .sb-findsim-v2 {
  display: flex;
  align-items: center;
  width: 80%;
  justify-content: center;
  border: 1px solid #54595f;
  border-radius: 2px;
  padding: 4px 0;
  margin: 4px auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #54595f;
}

.sb-fitpinkfitness .hs .sb-item--details .sb-clamp > h1 {
  font-family: "Arapey", serif !important;
  font-style: italic !important;
  font-size: 15px !important;
  line-height: 18px !important;
  height: 40px !important;
}

.sb-fitpinkfitness .hs .product-btn {
  width: 100% !important;
}
.sb-fitpinkfitness .hs .price {
  font-family: "Montserrat", sans-serif !important;
}
.sb-fitpinkfitness .sb-findsim-v2:hover {
  color: #fff;
  background: #ff3399;
  border-color: #ff3399;
}
.sb-osullivansafety .sb-findsim-v2 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  border: 1px solid #101f29;
  border-radius: 2px;
  padding: 4px 0;
  margin: 4px auto 4px;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #101f29;
}
.sb-osullivansafety .sb-findsim-v2:hover {
  color: #fff;
  background: #101f29;
}
.sb-osullivanspharmacy .hs img {
  height: 140px;
}
.sb-osullivanspharmacy #shopbox .sb-menu--btn {
  overflow: visible;
}
.sb-osullivanspharmacy .sb-findsim-v2 {
  cursor: pointer;
  font-size: 14px;
  display: inline-block;
  border: 2px solid #007abc;
  margin: 2px 0;
  color: #007abc;
  padding: 3px 21.5px;
  font-weight: 600;
  text-transform: uppercase;
}
.sb-osullivanspharmacy .outofstock .sb-findsim-v2 {
  padding: 3px 17px;
}
.sb-osullivanspharmacy .sb-findsim-v2:hover {
  color: #fff;
  background: #007abc;
}

@media (min-width: 768px) {
  .sb-euronics-grid .product-block {
    height: 580px !important;
  }
}

@media (max-width: 768px) {
  .sb-euronics-grid .product-block .row.show-for-small {
    padding-bottom: 6px;
  }
}
.sb-euronics .sb-findsim-v2 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  border: 1px solid #1d428a !important;
  border-radius: 2px;
  padding: 7px 0;
  margin: 0 auto;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #1d428a;
  position: relative;
  z-index: 13232 !important;
}

.sb-euronics .sb-findsim-v2:hover {
  background: #1d428a;
  color: #fff !important;
}
@media (max-width: 768px) {
  .shopbox-disable-website-scroll {
    overflow: hidden !important;
  }
}
.sb-outside-panel {
  display: none;
}
@media (max-width: 768px) {
  .sb-outside-panel {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    height: 25%;
    z-index: 2333333;
    width: 100vw;
  }

  #shopbox .sb-panel:not(.sb-cta) {
    height: 75% !important;
  }
  #shopbox .sb-panel.sb-menu--items {
    height: auto !important;
  }
  .shopbox-disable-website-scroll .shopbox-main:after {
    content: "";
    display: block;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.35;
    z-index: 2133433;
    background: #000;
  }
}
</style>

